import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { CaretDown } from "@phosphor-icons/react";
import { CalendlyButton } from "@/components/CalendlyButton";
import { CallButton } from "@/components/CallButton";
import { PrimaryCtaButton } from "@/components/PrimaryCtaButton";

const OVERLAY_MOTION = { initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 } };
const SLIDE_IN_FROM_LEFT = { initial: { opacity: 0, x: -24 }, animate: { opacity: 1, x: 0 } };
const DROPDOWN_EXPAND_MOTION = { initial: { height: 0, opacity: 0 }, animate: { height: "auto", opacity: 1 }, exit: { height: 0, opacity: 0 } };
const CTA_DELAY_TRANSITION = { delay: 0.4 };

export const MobileMenu = ({ open, navStructure, mobileExpanded, setMobileExpanded }) => (
  <AnimatePresence>
    {open && (
      <motion.div
        data-testid="navbar-mobile-menu"
        {...OVERLAY_MOTION}
        className="fixed inset-0 z-40 bg-white/95 dark:bg-black/95 backdrop-blur-2xl flex flex-col items-start justify-center gap-5 px-8 md:hidden overflow-y-auto py-24"
      >
        {navStructure.map((link, i) => (
          <motion.div key={link.path} {...SLIDE_IN_FROM_LEFT} transition={{ delay: 0.08 * i }} className="w-full">
            {link.dropdown ? (
              <div className="w-full">
                <button
                  type="button"
                  data-testid={`navbar-mobile-link-${link.label.toLowerCase()}`}
                  onClick={() => setMobileExpanded((v) => (v === link.label ? null : link.label))}
                  className="flex items-center gap-2 font-display text-4xl uppercase text-slate-900 dark:text-white"
                >
                  {link.label}
                  <CaretDown size={20} className={`transition-transform duration-300 ${mobileExpanded === link.label ? "rotate-180" : ""}`} />
                </button>
                <AnimatePresence>
                  {mobileExpanded === link.label && (
                    <motion.div {...DROPDOWN_EXPAND_MOTION} className="overflow-hidden">
                      <div className="flex flex-col gap-3 mt-4 pl-2">
                        {link.dropdown.map((item) => (
                          <Link
                            key={item.path}
                            to={item.path}
                            data-testid={`navbar-mobile-dropdown-item-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                            className="font-body text-lg text-slate-600 dark:text-slate-300"
                          >
                            {item.label}
                          </Link>
                        ))}
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            ) : (
              <Link to={link.path} data-testid={`navbar-mobile-link-${link.label.toLowerCase()}`} className="font-display text-4xl uppercase text-slate-900 dark:text-white">
                {link.label}
              </Link>
            )}
          </motion.div>
        ))}
        <motion.div {...SLIDE_IN_FROM_LEFT} transition={CTA_DELAY_TRANSITION} className="flex flex-col gap-4 mt-4">
          <PrimaryCtaButton className="btn-gradient inline-flex items-center gap-2" testId="navbar-mobile-cta" />
          <CalendlyButton className="btn-outline inline-flex items-center gap-2" testId="navbar-mobile-book-call-button" />
          <CallButton className="btn-outline inline-flex items-center gap-2" testId="navbar-mobile-call-button" />
        </motion.div>
      </motion.div>
    )}
  </AnimatePresence>
);
